var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B17AE446-529D-431E-987C-487A73BE4748") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Dashboard",
    transform: "translate(-32.000000, -376.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winter-Card-Copy-2",
    transform: "translate(16.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "appointment",
    transform: "translate(16.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C15,4.13400675 11.8659932,1 8,1 Z M8,3 C8.25641792,3 8.46775358,3.1930201 8.49663613,3.44168944 L8.5,3.5 L8.5,7.7925 L11.5927956,10.884285 C11.7730766,11.0644879 11.7870029,11.3481005 11.6345329,11.5442791 L11.5929489,11.5913918 C11.4127459,11.7716728 11.1291334,11.7855991 10.9329548,11.6331291 L10.8858421,11.591545 L7.64652324,8.35363001 C7.56834402,8.27548466 7.51871125,8.1741203 7.50433864,8.06574027 L7.5,8 L7.5,3.5 C7.5,3.22385763 7.72385763,3 8,3 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.8f3708ecc88a4a2cdfed4a2ddbbcb60d.svg";
export { ForwardRef as ReactComponent };